import * as React from 'react';
import useAuth from '../../features/hooks/useAuth';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';
import Input from '@mui/material/Input';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import moment from 'moment';



const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const DailogActionWrapper =styled.div`
  display: flex;
  align-content: flex-end;
  
`

const FieldWrapper = styled.div`
  display: flex;
`

const FieldLabel = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const FieldValue = styled.div`
  margin-bottom: 15px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 8px;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

const datePickerStyle = styled.div`
  background-color:lightgreen ;
`
const cadreArray = ["CWES-GrA", "CWES-GrB", "Hydromet", "Scientific","Others"];

export default function ApproveUserModal({approvemodalopen, handleApproveModalClose, approveModaldata, handleApproveFormSubmit, onChangeEditdata, designations }) {

  const Auth = useAuth();
  console.log(approveModaldata?.row)

  const fields = approveModaldata? [
    { label: 'Request Type', value: approveModaldata?.row?.reqType === "joinoffreq"? "Office Joining request":"New Signup Request" },
    { label: 'Email', value: approveModaldata?.row?.email },
    { label: 'Name', value: `${approveModaldata?.row?.name.firstName} ${approveModaldata?.row?.name?.middleName} ${approveModaldata?.row?.name.lastName}` },
    { label: 'Join Office Requested ', value: approveModaldata?.row?.reqType === "joinoffreq"? approveModaldata?.row?.currentOffice: approveModaldata?.row?.office.mainCharge },
    { label: 'Charge Type Requested', value: approveModaldata?.row?.chargeType === "additional"? "Additional":"Main" },
    { label: 'Designation Requested', value: approveModaldata?.row?.reqType === "joinoffreq"? approveModaldata?.row?.designation[approveModaldata?.row?.currentOffice]:approveModaldata?.row?.designation[approveModaldata?.row?.office.mainCharge] }   
    // { label: 'Previously Held Main Office', value: approveModaldata?.row?.reqType === "joinoffreq"? approveModaldata?.userObject.office.mainCharge:"Not Applicable"},
    // { label: 'Previously Held Additional Charges', value: approveModaldata?.row?.reqType === "joinoffreq"? approveModaldata?.userObject.office.additionalCharge.length? approveModaldata?.userObject.office.additionalCharge.join(","):"No Additional Charge":"Not Applicable" }
  ]:[];

  return (
    <React.Fragment>
      <Dialog  onClose={handleApproveModalClose} aria-labelledby="customized-dialog-title" open={approvemodalopen}>
        <DialogTitle>{approveModaldata.type === "approve"? "Please Check User Details Before Approving":"Are You Sure You Want to Reject"}</DialogTitle>
        <form onSubmit={handleApproveFormSubmit}>
          <DialogContent dividers>
            <ModalContent>
              <Table>
              <tbody>
              {fields.map((item, index)=>
                <tr id='email' key ={index}>
                    <TableCell>
                      <TableHeader>
                        {item?.label}
                      </TableHeader>
                    </TableCell>
                    
                    <TableCell>
                      { item?.value}
                    </TableCell>
                  </tr>
                )
              }

              {/* <tr id='email'>
                  <TableCell>
                    <TableHeader>
                      {fields[5].label}
                    </TableHeader>
                  </TableCell>
                  
                  <TableCell>
                    { fields[5].value}
                  </TableCell>
                </tr>
                
                <tr id='email'>
                  <TableCell>
                    <TableHeader>
                      {fields[0].label}
                    </TableHeader>
                  </TableCell>
                  
                  <TableCell>
                    { fields[0].value}
                  </TableCell>
                </tr>

                <tr id='name'>
                  <TableCell>
                    <TableHeader>
                      {fields[1].label}
                    </TableHeader>
                  </TableCell>
                  <TableCell>{moment(fields[1].value).format('DD/MM/YYYY') === "Invalid date"? fields[1].value:moment(fields[1].value).format('DD/MM/YYYY')}</TableCell>
                </tr>        

                <tr  id='office'>
                  <TableCell>
                    <TableHeader>
                      {fields[2].label}
                    </TableHeader>
                  </TableCell>
                  <TableCell>{fields[2].value}</TableCell>
                </tr>

                <tr id='office charge'>
                  <TableCell>
                    <TableHeader>
                      {fields[3].label}
                    </TableHeader>
                  </TableCell>
                  <TableCell>{fields[3].value}</TableCell>
                </tr>

                <tr id='designation'>
                  <TableCell>
                    <TableHeader>
                      {fields[4].label}
                    </TableHeader>
                  </TableCell>
                  <TableCell>{fields[4].value}</TableCell>
                </tr>                 */}
            </tbody>
                  </Table>
            </ModalContent>
          </DialogContent>

            <DialogActions >
              <Button type='submit'>{approveModaldata.type === "approve"? "Approve":"Reject"}</Button>
              <Button onClick={handleApproveModalClose}>Close</Button>
            </DialogActions>
            </form>
      </Dialog>
    </React.Fragment>
  );
}
